// eslint-disable-next-line import/no-extraneous-dependencies
import Swiper from 'swiper/bundle';

if (document.querySelector('[data-role="artworks-facility-map-swiper"]') !== null) {
  // eslint-disable-next-line no-new
  let artworksFacilityMapSwiper = new Swiper('[data-role="artworks-facility-map-swiper"]', {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    centerInsufficientSlides: true,
    centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 1500,
    navigation: {
      nextEl: '[data-role="artworks-facility-map-swiper-nav-next"]',
      prevEl: '[data-role="artworks-facility-map-swiper-nav-prev"]',
    },
  });
}